import { motion } from "framer-motion";
import { STATS } from "@/data/content";

const BG = {
  yellow: "bg-yellow text-obsidian",
  obsidian: "bg-obsidian text-white",
  coral: "bg-coral text-white",
  white: "bg-white text-obsidian",
};

export const Stats = () => {
  return (
    <section data-testid="stats" className="py-16 md:py-24 px-5 md:px-10">
      <div className="max-w-[1400px] mx-auto grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-5">
        {STATS.map((s, i) => (
          <motion.div
            key={s.label}
            initial={{ opacity: 0, y: 40, rotate: -3 }}
            whileInView={{ opacity: 1, y: 0, rotate: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ type: "spring", stiffness: 120, damping: 12, delay: i * 0.08 }}
            whileHover={{ scale: 1.05, rotate: i % 2 ? 2 : -2 }}
            className={`rounded-3xl p-6 md:p-8 flex flex-col gap-1 border-2 border-obsidian/10 ${BG[s.color] || BG.obsidian}`}
          >
            <span className="font-anton text-4xl md:text-6xl leading-none">{s.value}</span>
            <span className="font-outfit text-xs md:text-sm uppercase tracking-wider opacity-80">
              {s.label}
            </span>
          </motion.div>
        ))}
      </div>
    </section>
  );
};
